<ng-container [formGroup]="parent">
  <ng-container formGroupName="header">
    <div class="gray-bg-rounded">
      <div class="row">
        <div class="col-6">
          <div class="form-group has-float-label mb-2">
            <label class="form-label">Template Name</label>
            <p-select
              formControlName="templateId"
              (onChange)="onTemplateSelection()"
              [options]="templates"
              optionLabel="name"
              optionValue="id"
              [filter]="true"
              [showClear]="true">
            </p-select>
          </div>
        </div>
        <div class="col-6" *ngIf="displaySaleOrderSection">
          <div class="form-group has-float-label mb-2">
            <label class="form-label">Proposal #</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              type="text"
              class="form-control"
              formControlName="workflowId" />
          </div>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col-6">
              <div class="form-group has-float-label mb-2">
                <label class="form-label">Sender</label>
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control"
                  placeholder=""
                  formControlName="sender" />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group has-float-label mb-2">
                <label class="form-label">Reply</label>
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control"
                  placeholder=""
                  formControlName="reply" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6 col-min-6">
              <div class="form-group has-float-label mb-2">
                <label class="form-label">Projects</label>
                <p-select
                  [(ngModel)]="projectIdForFiles"
                  (onChange)="onProjectSelectionChangesForFiles()"
                  [ngModelOptions]="{ standalone: true }"
                  [options]="projectHeaderList"
                  optionValue="projectId"
                  [filter]="true"
                  [showClear]="true">
                  <ng-template let-element #item>
                    {{
                      element.paddedProjectId +
                        " - " +
                        element.customerName +
                        " - " +
                        element.jobName
                    }}
                  </ng-template>
                  <ng-template let-element #selectedItem>
                    {{
                      element.paddedProjectId +
                        " - " +
                        element.customerName +
                        " - " +
                        element.jobName
                    }}
                  </ng-template>
                </p-select>
              </div>
            </div>
            <div class="col-6 col-min-6 d-flex">
              <div class="form-group has-float-label mb-2 col-lg">
                <label class="form-label">Files</label>
                <p-select
                  [(ngModel)]="projectFile"
                  [ngModelOptions]="{ standalone: true }"
                  [filter]="true"
                  [showClear]="true"
                  [options]="projectFilesList"
                  optionLabel="fileName">
                </p-select>
              </div>

              <div
                class="row add-file-button-align px-2 mt-3 pt-2"
                *ngIf="projectFilesList.length > 0">
                <p-button
                  (onClick)="onAddProjectFileAttachment()"
                  [label]="'Add'">
                </p-button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 d-flex">
          <div class="form-group has-float-label mb-2">
            <label class="form-label">Additional Subject</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              type="text"
              class="form-control"
              formControlName="additionalSubject"
              (change)="onAdditionalSubject($event)"
              (blur)="logValidationErrors()" />
          </div>
        </div>

        <div class="col-3 subject-margin">
          <div class="form-group has-float-label mb-2">
            <label class="form-label">Subject</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              type="text"
              class="form-control"
              placeholder=""
              formControlName="subject"
              [disabled]="true"
              [ngClass]="{ 'has-error': formErrors['subject'] }"
              (blur)="logValidationErrors()" />

            <span class="error-msg" *ngIf="formErrors['subject']">
              {{ formErrors["subject"] }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
